// extracted by mini-css-extract-plugin
export var circle = "_4e-2";
export var icon = "_4e-a";
export var iconHighlight = "_4e-0";
export var lg = "_4e-8";
export var md = "_4e-7";
export var outline = "_4e-4";
export var sm = "_4e-6";
export var square = "_4e-1";
export var xl = "_4e-9";
export var xs = "_4e-5";
export var xxs = "_4e-3";